import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import styles from './SuccessResend.module.css';


export function SuccessResend() {
    const {t} = useTranslation();

    return (

        <>

            <div className="container-fluid">
                <div className="container">
                    <div className={"signup_section loginbg "+ styles.loginbg}>
                        <div className="header_sign">
                            <ul>
                                <li>
                                    <Link to="/">
                                        <img
                                            src={window.location.origin + "/images/left_arrow.svg"}
                                        />
                                        <span>{t("text-home")}</span>
                                    </Link>
                                </li>
                                <li className="login">
                                    <span>{t("have-account")}</span>
                                    <Link to="/signup">{t("sign-up")}</Link>
                                </li>
                            </ul>
                        </div>

                        <div className={"more_about login_form "+styles.Form}>
                            <img src={window.location.origin + "/images/sign_logo.svg"}/>
                            <h2>{t("header-resend-thank-you")}</h2>

                            <div>

                                <div className={styles.thankYouDescription} dangerouslySetInnerHTML={{__html: t("text-resend-thank-you") }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
        </>


    );
}